import React, { Component } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import BasInstanceTable from './BasInstanceTable';

class BasFloorAccordion extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeCollapse: 0,
    };
    this.initialState = this.state;
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse(index) {
    const { activeCollapse } = this.state;
    this.setState({
      activeCollapse: index !== activeCollapse ? index : -1
    });
  }

  render() {

    const { floor } = this.props;
    const { activeCollapse } = this.state;

    return (
      <>
        {
          floor.map((item, i) => (
            <Card key={i}>
              <CardHeader className={'card-header bg-dark text-white pointer-cursor ' + (activeCollapse !== i ? 'collapsed ' : '')} onClick={() => this.toggleCollapse(i)}>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <span>{item.name}</span>
                  <i className={`fa ${activeCollapse === i ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                </div>
              </CardHeader>
              <Collapse isOpen={activeCollapse === i}>
                <CardBody>
                  <BasInstanceTable
                    instanceData={item.instance}
                  />
                </CardBody>
              </Collapse>
            </Card>
          ))
        }
      </>
    )
  }
}

export default BasFloorAccordion;
